import { z } from 'zod';
import { REQUIRED_ERROR, inputsLength, latinAlphanumericRegex } from '@/domains/auth/constants/validation';

export const validationSchema = z
  .object({
    temporaryPassword: z
      .string({ required_error: REQUIRED_ERROR })
      .min(1, {
        message: REQUIRED_ERROR,
      })
      .regex(latinAlphanumericRegex),
    newPassword: z
      .string({ required_error: REQUIRED_ERROR })
      .min(1, { message: REQUIRED_ERROR })
      .min(inputsLength.password.min, {
        message: `Please, make sure password is at least ${inputsLength.password.min} characters long`,
      })
      .max(inputsLength.password.max, {
        message: `Password input exceeds ${inputsLength.password.max} characters`,
      }),
    confirmPassword: z
      .string({ required_error: REQUIRED_ERROR })
      .min(1, { message: REQUIRED_ERROR })
      .min(inputsLength.password.min, {
        message: `Please, make sure password is at least ${inputsLength.password.min} characters long`,
      })
      .max(inputsLength.password.max, {
        message: `Password input exceeds ${inputsLength.password.max} characters`,
      }),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Oops! Entered data did not match. Please try again',
    path: ['confirmPassword'],
  });
